import { render } from "./agentGrowth.vue?vue&type=template&id=522be934&scoped=true"
import script from "./agentGrowth.vue?vue&type=script&lang=js"
export * from "./agentGrowth.vue?vue&type=script&lang=js"

import "./agentGrowth.vue?vue&type=style&index=0&id=522be934&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522be934"]])

export default __exports__